import makeRequest from "./makeRequest";
import getRuntimeConstants from "../runtimeConstants";
import { getAuthorisationHeader } from "../utils/identity";
import { GET } from "../constants";

export default async function getReturnsChargeMessaging(segmentIds) {
  const {
    webContext: { browseCountry },
    returnsChargeMessagingApiUrl,
    returnsChargeMessagingApiTimeout,
  } = getRuntimeConstants();

  const now = new Date();
  const params = {
    effectiveDate: now.toISOString().split("T")[0],
    country: browseCountry,
  };

  const authorisation = await getAuthorisationHeader();

  const response = await makeRequest({
    url: returnsChargeMessagingApiUrl,
    params,
    timeout: returnsChargeMessagingApiTimeout,
    method: GET,
    headers: {
      authorisation,
      ...(segmentIds && { "asos-c-segmentids": segmentIds }),
    },
    apiName: "Returns Charge Messaging",
    caller: "ReturnsChargeMessaging",
    handleErrorReturnValue: () => null,
  });

  return response;
}
